import { Component, OnInit, Input } from '@angular/core';

//-------------------------------------------------------------------------------------------
// Author:      Martin Unger
// Created:     09/11/2017
// Description: Component to display a footer at the bottom of each component that uses it
//--------------------------------------------------------------------------------------------
@Component({
  selector: 'app-footer',
  templateUrl: './portal-footer.component.html',
  styleUrls: ['./portal-footer.component.css']
})
export class PortalFooterComponent implements OnInit { 
 
  @Input() footer: string;      //Text to appear in the footer section
  @Input() copyright: string;   //Text to appear in the copyright section
  @Input() displayFooter:boolean;
  
  constructor() { }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/components/portal-footer/portal-footer.component.ts